<div class="file" [attr.extension]="file.extension" *ngFor="let file of files">

    <file-icon [extension]="file.extension" [unsupported]="file.error === 'format'"></file-icon>

    <div class="name" title="{{file.name}}">{{file.name}}</div>

    <div class="size" *ngIf="!file.error">{{file.size | fileSize}}</div>

    <div class="pages" *ngIf="!file.error">
        <span *ngIf="file.progress == 100 && file.statistics">
            <b>{{file.statistics.pages}}</b>
            <span i18n>{file.statistics.pages, plural, =1 {Page} other {Pages}}</span>
        </span>
    </div>

    <div class="error" *ngIf="file.error" [ngSwitch]="file.error">
        <svg-icon src="/assets/icons/alert.svg"></svg-icon>
        <span *ngSwitchCase="'corrupted'" [uiTooltip]="'The file is corrupted'"></span>
        <span *ngSwitchCase="'empty'" [uiTooltip]="'The file is empty'"></span>
        <span *ngSwitchCase="'encrypted'" [uiTooltip]="'The file is protected by a password'"></span>
        <span *ngSwitchCase="'format'" [uiTooltip]="'Unsupported file format'"></span>
        <span *ngSwitchCase="'maximum'" [uiTooltip]="'The file size exceeds the maximum of 25 MB'"></span>
        <span *ngSwitchCase="'upload'" [uiTooltip]="'Upload error'"></span>
        <span *ngSwitchDefault [uiTooltip]="'An error occurred during the file recognition'"></span>
    </div>

    <ui-progress-bar *ngIf="!file.error && file.progress < 100" [value]="file.progress"></ui-progress-bar>

    <svg-icon class="cancel"
              src="/assets/icons/cross-thing.svg"
              *ngIf="file.progress < 100"
              (click)="remove(file)"></svg-icon>

    <svg-icon class="remove"
              src="/assets/icons/delete.svg"
              *ngIf="file.progress == 100"
              (click)="remove(file)"></svg-icon>

</div>